import styled from "styled-components"
import { Colors } from "styles/app-styles"
import { InputBaseStyles } from 'styles/input-styles'
import DateText from 'components/inputs/date-text';

export const PropertySettings_s = styled.div`
  #link-asset-button {
    margin-top:29px;
  }
  > .input-group {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin-left: 15px;
    > div {
      display: flex;
      flex-direction: column;
      padding: 15px;
      > label {
        margin-bottom: 10px;
      }
      > input, select {
        width: 180px;
      }
    }
  }
  > .blue-input-group {
    background-color: ${Colors.inputFocus};
    border: 1px solid ${Colors.towerGrey};
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 15px;
    > div {
      display: flex;
      flex-direction: column;
      padding: 15px;
      > label {
        margin-bottom: 10px;
      }
      > input, select {
        width: 180px;
      }
    }
  }
  .lease-types-container {
    .labels {
      margin-bottom: 10px;
      label:first-child {
        margin-right: 158px;
      }
    }
    .carousel-multi-row {
      input {
        width: 190px;
      }
    }
  }
  .has-errors {
    border-bottom-width: 1px !important;
    border-bottom-color: ${Colors.colorDanger} !important;
  }
  .propertyUnderwriting {
    .row {
      display: flex;
      flex-direction: row;
    }
    .column {
      display: flex;
      flex-direction: column;
      padding: 15px;
      > label {
        margin-bottom: 10px;
      }
      select {
        width: 230px;
      }
      > input {
        width: 100px;
      }
    }
    button {
      margin-left: 15px;
      margin-right: 15px;
      margin-bottom: 10px;
    }
  }

  textarea {
    border-color: ${Colors.towerGrey};
    border-radius: 2px;
    color: ${Colors.blackPearl};
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    padding: 8px;
    &:focus {
      outline: 1px solid ${Colors.blackPearl};
    }
  }
`

export const DateText_s = styled(DateText)`
  ${InputBaseStyles}
  padding: 0 8px;
  outline: none;
  width: 155px;
`

export const Icon_s = styled.div`
  align-self: start;
  cursor: pointer;
  display: flex;
  margin-top: 5px;
  a {
    cursor: pointer;
    opacity: 1;
  }
  a.disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }

  svg {
    height: 20px;
    width: auto;
    .r-svg {
      fill: ${Colors.blackPearl};
      height: 100%;
    }
  }
`